
import React from 'react'
import SymptomCheckerWizard from '../components/SymptomsCheckerFlow/SymptomCheckerWizard'
import DigitalHealthFAB from '../components/Digitalhealth'
// import PreScreeningQuestions from '../components/SymptomChecker/PreScreeningQuestions'
// import MultiSymptomSelect from '../components/SymptomChecker/MultiSymptomSelect'

function symptoms() {

  return (
    <div>
      <DigitalHealthFAB />
      {/* <MultiSymptomSelect /> */}
      <SymptomCheckerWizard />
    </div>
  )
}

export default symptoms


// import React, { useState, Fragment } from 'react';
// import MultiSymptomChecker from '../components/SymptomChecker/MultiSymptomSelect';
// import PreScreeningQuestions from '../components/SymptomChecker/PreScreeningQuestions';

// /* ─── Step config ───────────────────────────────────────────────────── */
// const STEPS = [
//   { id: 1, label: "Pre-Screening",      short: "Pre-Screen" },
//   { id: 2, label: "Check Symptoms",     short: "Symptoms"   },
//   { id: 3, label: "Assessment",         short: "Assessment" },
//   { id: 4, label: "Results",            short: "Results"    },
// ];

// /* ─── Step Progress Bar ─────────────────────────────────────────────── */
// const StepProgressBar = ({ currentStep }) => {
//   const c = {
//     primary: "#00246B",
//     blue: "#e8f0fe",
//     gray200: "#e5e7eb",
//     gray400: "#9ca3af",
//     textLight: "#6b7280",
//   };

//   return (
//     <div style={{
//       backgroundColor: "#fff",
//       borderBottom: `1px solid ${c.gray200}`,
//       padding: "14px 32px",
//       boxShadow: "0 1px 4px rgba(0,36,107,0.06)",
//     }}>
//       <div style={{
//         maxWidth: 740,
//         margin: "0 auto",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         position: "relative",
//       }}>

//         {/* Connector line behind steps */}
//         <div style={{
//           position: "absolute",
//           top: "50%",
//           left: "10%",
//           right: "10%",
//           height: 2,
//           backgroundColor: c.gray200,
//           transform: "translateY(-50%)",
//           zIndex: 0,
//         }} />

//         {/* Active progress fill */}
//         <div style={{
//           position: "absolute",
//           top: "50%",
//           left: "10%",
//           width: `${((currentStep - 1) / (STEPS.length - 1)) * 80}%`,
//           height: 2,
//           backgroundColor: c.primary,
//           transform: "translateY(-50%)",
//           zIndex: 1,
//           transition: "width 0.4s ease",
//         }} />

//         {STEPS.map((step) => {
//           const isDone    = currentStep > step.id;
//           const isActive  = currentStep === step.id;
//           const isPending = currentStep < step.id;

//           return (
//             <div key={step.id} style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 6,
//               zIndex: 2,
//               position: "relative",
//             }}>
//               {/* Circle */}
//               <div style={{
//                 width: 34,
//                 height: 34,
//                 borderRadius: "50%",
//                 backgroundColor: isDone ? c.primary : isActive ? c.primary : "#fff",
//                 border: `2px solid ${isPending ? c.gray200 : c.primary}`,
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 transition: "all 0.3s ease",
//                 boxShadow: isActive ? "0 0 0 4px rgba(0,36,107,0.12)" : "none",
//               }}>
//                 {isDone ? (
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                     <polyline points="20 6 9 17 4 12"/>
//                   </svg>
//                 ) : (
//                   <span style={{
//                     fontSize: 12,
//                     fontWeight: 700,
//                     color: isActive ? "#fff" : c.gray400,
//                   }}>{step.id}</span>
//                 )}
//               </div>

//               {/* Label */}
//               <span style={{
//                 fontSize: 11,
//                 fontWeight: isActive ? 700 : 500,
//                 color: isActive ? c.primary : isPending ? c.gray400 : c.primary,
//                 whiteSpace: "nowrap",
//               }}>
//                 {step.short}
//               </span>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// /* ─── Placeholder for upcoming steps ───────────────────────────────── */
// const PlaceholderStep = ({ stepNumber, title, onBack }) => (
//   <div style={{
//     minHeight: "100vh",
//     background: "linear-gradient(135deg,#eef2f9 0%,#e8edf8 50%,#f0f4fd 100%)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: 32,
//   }}>
//     <div style={{
//       backgroundColor: "#fff",
//       borderRadius: 20,
//       padding: "48px 40px",
//       textAlign: "center",
//       boxShadow: "0 8px 40px rgba(0,36,107,0.10)",
//       maxWidth: 480,
//       width: "100%",
//     }}>
//       <div style={{
//         width: 64,
//         height: 64,
//         borderRadius: "50%",
//         backgroundColor: "#e8f0fe",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         margin: "0 auto 16px",
//         fontSize: 28,
//       }}>
//         🚧
//       </div>
//       <h2 style={{ fontSize: 22, fontWeight: 700, color: "#00246B", margin: "0 0 8px" }}>
//         Step {stepNumber}: {title}
//       </h2>
//       <p style={{ fontSize: 14, color: "#6b7280", marginBottom: 28 }}>
//         This step is coming soon. It will be integrated into the flow shortly.
//       </p>
//       <button
//         onClick={onBack}
//         style={{
//           padding: "10px 24px",
//           borderRadius: 10,
//           fontSize: 14,
//           fontWeight: 600,
//           backgroundColor: "#e8f0fe",
//           color: "#00246B",
//           border: "none",
//           cursor: "pointer",
//         }}
//       >
//         ← Go Back
//       </button>
//     </div>
//   </div>
// );

// /* ─── Main Symptoms Page ─────────────────────────────────────────────── */
// const Symptoms = () => {
//   const [currentStep,        setCurrentStep]        = useState(1);
//   const [preScreeningData,   setPreScreeningData]   = useState(null);
//   const [symptomCheckerData, setSymptomCheckerData] = useState(null);

//   const goToStep = (n) => setCurrentStep(n);

//   const handlePreScreeningComplete = (data) => {
//     setPreScreeningData(data);
//     goToStep(2);
//   };

//   const handleSymptomCheckerContinue = (symptoms) => {
//     setSymptomCheckerData(symptoms);
//     goToStep(3);
//   };

//   return (
//     <Fragment>
//       {/* Step progress bar — always visible */}
//       {/* <StepProgressBar currentStep={currentStep} /> */}

//       {/* Step 1 — Pre-Screening */}
//       {currentStep === 1 && (
//         <PreScreeningQuestions
//           onComplete={handlePreScreeningComplete}
//         />
//       )}

//       {/* Step 2 — Symptom Checker */}
//       {currentStep === 2 && (
//         <MultiSymptomChecker
//           onBack={() => goToStep(1)}
//           onContinue={handleSymptomCheckerContinue}
//         />
//       )}

//       {/* Step 3 — Assessment (coming soon) */}
//       {currentStep === 3 && (
//         <PlaceholderStep
//           stepNumber={3}
//           title="Assessment"
//           onBack={() => goToStep(2)}
//         />
//       )}

//       {/* Step 4 — Results (coming soon) */}
//       {currentStep === 4 && (
//         <PlaceholderStep
//           stepNumber={4}
//           title="Results"
//           onBack={() => goToStep(3)}
//         />
//       )}
//     </Fragment>
//   );
// };

// export default Symptoms;

// import React from 'react'
// import PreScreeningQuestions from '../components/SymptomChecker/PreScreeningQuestions'
// import MultiSymptomSelect from '../components/SymptomChecker/MultiSymptomSelect'

// function symptoms() {
//   return (
//     <div>
//       <MultiSymptomSelect />
//     </div>
//   )
// }

// export default symptoms